import nearestColor from 'nearest-color'
import colorNames from '../constants/colornames.bestof.min.json'


const stringCustomColor = Lang.langGet('Custom color')
let nearestColorInstance = null

/**
 * Return a human-readable name for a given color.
 * @param colorHex {string} Hex formatted color (with '#' in front)
 * @returns {string} Human-readable name for color
 */
export function colorHexToName(colorHex) {

    /*if (colorHex.length > 7) {
        colorHex = colorHex.slice(0, 7)
    }*/

    if (!nearestColorInstance) {
        nearestColorInstance = nearestColor.from(colorNames)
    }

    const nearestResult = nearestColorInstance(colorHex)
    return nearestResult.distance > 32 ? stringCustomColor : nearestResult.name
}
